export const API_URL = process.env.REACT_APP_API_URL ?? '';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY ?? '';
export const APP_VERSION = process.env.REACT_APP_VERSION ?? '1.0.0';
